import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function ContactMap() {
  return (
    <section className="bg-white">
      <div className="w-full">
        <ScrollReveal>
          <div className="w-full h-[300px] md:h-[400px] lg:h-[480px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116834.15093170028!2d90.3493!3d23.8742!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c43a55a5e7c9%3A0x2e3f5a6b8c9d0e1f!2sUttara%2C%20Dhaka!5e0!3m2!1sen!2sbd!4v1715000000000!5m2!1sen!2sbd"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="TIE Office Location - Uttara, Dhaka"
              className="grayscale-[20%]"
            />
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
}